// extracted by mini-css-extract-plugin
module.exports = {"fab":"Control_fab__to75Q"};